import { gmailLink, socialMedia } from "./constants";
import { Container, Image, ImagesContainer } from "./styles";
import gmail from '../../assets/Social/gmail.svg';
export default function SocialMedia() {
    return (
        <Container>
            <ImagesContainer>
                {socialMedia.map((item, index) => {
                    return (
                        <Image key={index} src={item.src} alt={item.name} onClick={() => window.open(item.link)} />
                    );
                })}
                <Image src={gmail} alt={'Gmail'} onClick={() => { window.open(gmailLink, '_self'); }} />
            </ImagesContainer>
        </Container>
    );
}